import React from "react";
import type { Contact } from "../../../types/contact";
import {
  StyledContactsList,
  StyledContactItem,
  StyledEmptyState,
} from "./index.styled";
import ContactIcon from "../../../assets/icons/contact-icon.png";

interface ContactsListProps {
  contacts: Contact[];
}

const ContactsList: React.FC<ContactsListProps> = ({ contacts }) => {
  if (contacts.length === 0) {
    return (
      <StyledEmptyState>
        <div className="empty-icon">📋</div>
        <div className="empty-title">אין אנשי קשר זמינים</div>
        <div className="empty-subtitle">
          נסה לשנות את הסינון או לבדוק מאוחר יותר
        </div>
      </StyledEmptyState>
    );
  }

  return (
    <StyledContactsList>
      {contacts.map((contact: Contact, index: number) => (
        <StyledContactItem key={`${contact.id}-${contact.phone}-${index}`}>
          <img src={ContactIcon} alt="contact" />
          <div className="contact-info">
            <div className="contact-name">{contact.name}</div>
            <a href={`tel:${contact.phone}`} className="contact-phone">
              {contact.phone}
            </a>
          </div>
          <div className="contact-date">
            <div
              className="contact-source"
              style={{
                backgroundColor: contact.sourceColor
                  ? `${contact.sourceColor}20`
                  : undefined,
              }}
            >
              <span style={{textAlign: "center"}}>{contact.source}</span>
            </div>
            <div className="contact-join-date">{contact.joinDate}</div>
          </div>
        </StyledContactItem>
      ))}
    </StyledContactsList>
  );
};

export default ContactsList;
